import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthAPI } from '../../api/client';
import { AuthLayout, ErrorText, input, label, button, linkRow, linkStyle } from './authShared';

/** Handles Cognito's EMAIL_OTP MFA challenge — the second factor required once the
 *  pool enforces email MFA. Reached from /login (or /new-password) after an
 *  `mfa_required` result; the in-flight challenge lives in a short-lived httpOnly
 *  cookie set by the backend, so this screen only needs the emailed code.
 *
 *  There's no resend: the code can't be re-issued without re-authenticating (the
 *  password is never persisted), so an expired code means starting over at /login. */
export default function EmailMfaChallenge() {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!code.trim()) { setError('Enter the code we emailed you.'); return; }
    setBusy(true);
    const r = await AuthAPI.verifyMfa(code.trim());
    if (r.ok && r.status === 'ok') { window.location.assign('/'); return; }
    setBusy(false);
    setError(r.message || 'That code is invalid or has expired. Please sign in again.');
  };

  return (
    <AuthLayout title="Enter your code" subtitle="We emailed you a one-time sign-in code.">
      <form onSubmit={submit}>
        <label style={label}>Verification code
          <input style={input} inputMode="numeric" autoComplete="one-time-code" value={code}
                 onChange={e => setCode(e.target.value)} autoFocus />
        </label>
        <ErrorText>{error}</ErrorText>
        <button type="submit" style={button} disabled={busy}>{busy ? 'Verifying…' : 'Verify & sign in'}</button>
      </form>
      <p style={linkRow}>
        Didn’t get a code? <Link to="/login" style={linkStyle}>Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
